import { render } from "./IconChevronLeft.vue?vue&type=template&id=58441b90&ts=true"
import script from "./IconChevronLeft.vue?vue&type=script&lang=ts"
export * from "./IconChevronLeft.vue?vue&type=script&lang=ts"

import "./IconChevronLeft.vue?vue&type=style&index=0&id=58441b90&lang=scss"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__